// ACTION CREATOR SET_LOADING_FULL_DATA
export const SET_LOADING_FULL_DATA = 'SET_LOADING_FULL_DATA';

// ACTION CREATOR setLoadingFullData
export const setLoadingFullData = (value) => ({
  type: SET_LOADING_FULL_DATA,
  value,
});

// ACTION CREATOR SAVE_STATION_SHORT_DATA
export const SAVE_STATION_SHORT_DATA = 'SAVE_STATION_SHORT_DATA';

// ACTION CREATOR setLoadingFullData
export const saveStationShortData = (value) => ({
  type: SAVE_STATION_SHORT_DATA,
  value,
});

// ACTION CREATOR SET_SAVE_FULL_ONE_STATION_DATA
export const SET_SAVE_FULL_ONE_STATION_DATA = 'SET_SAVE_FULL_ONE_STATION_DATA';

// ACTION CREATOR setSaveFullOneStationData
export const setSaveFullOneStationData = (value) => ({
  type: SET_SAVE_FULL_ONE_STATION_DATA,
  value,
});

// ACTION CREATOR SET_FULL_DATA_AVAILABLE
export const SET_FULL_DATA_AVAILABLE = 'SET_FULL_DATA_AVAILABLE';

// ACTION CREATOR setFullDataAvailable
export const setFullDataAvailable = (value) => ({
  type: SET_FULL_DATA_AVAILABLE,
  value,
});

// ACTION CREATOR SET_SAVE_SESSION_VIEW_DATA
export const SET_SAVE_SESSION_VIEW_DATA = 'SET_SAVE_SESSION_VIEW_DATA';

// ACTION CREATOR setSaveSessionViewData
export const setSaveSessionViewData = (value) => ({
  type: SET_SAVE_SESSION_VIEW_DATA,
  value,
});

// ACTION CREATOR SET_SAVE_ANTENNA_LIST
export const SET_SAVE_ANTENNA_LIST = 'SET_SAVE_ANTENNA_LIST';

// ACTION CREATOR setSaveAntennaList
export const setSaveAntennaList = (value) => ({
  type: SET_SAVE_ANTENNA_LIST,
  value,
});

// ACTION CREATOR SET_SAVE_RADOME_LIST
export const SET_SAVE_RADOME_LIST = 'SET_SAVE_RADOME_LIST';

// ACTION CREATOR setSaveRadomeList
export const setSaveRadomeList = (value) => ({
  type: SET_SAVE_RADOME_LIST,
  value,
});

// ACTION CREATOR SET_SAVE_RECEIVER_LIST
export const SET_SAVE_RECEIVER_LIST = 'SET_SAVE_RECEIVER_LIST';

// ACTION CREATOR setSaveReceiverList
export const setSaveReceiverList = (value) => ({
  type: SET_SAVE_RECEIVER_LIST,
  value,
});

// ACTION CREATOR SET_SAVE_HUMIDITY_SENSOR_LIST
export const SET_SAVE_HUMIDITY_SENSOR_LIST = 'SET_SAVE_HUMIDITY_SENSOR_LIST';

// ACTION CREATOR setSaveHumiditySensorList
export const setSaveHumiditySensorList = (value) => ({
  type: SET_SAVE_HUMIDITY_SENSOR_LIST,
  value,
});

// ACTION CREATOR SET_SAVE_PRESSURE_SENSOR_LIST
export const SET_SAVE_PRESSURE_SENSOR_LIST = 'SET_SAVE_PRESSURE_SENSOR_LIST';

// ACTION CREATOR setSavePressureSensorList
export const setSavePressureSensorList = (value) => ({
  type: SET_SAVE_PRESSURE_SENSOR_LIST,
  value,
});

// ACTION CREATOR SET_SAVE_TEMPERATURE_SENSOR_LIST
export const SET_SAVE_TEMPERATURE_SENSOR_LIST = 'SET_SAVE_TEMPERATURE_SENSOR_LIST';

// ACTION CREATOR setSaveTemperatureSensorList
export const setSaveTemperatureSensorList = (value) => ({
  type: SET_SAVE_TEMPERATURE_SENSOR_LIST,
  value,
});

// ACTION CREATOR SET_SAVE_WATER_VAPOR_SENSOR_LIST
export const SET_SAVE_WATER_VAPOR_SENSOR_LIST = 'SET_SAVE_WATER_VAPOR_SENSOR_LIST';

// ACTION CREATOR setSaveWaterVaporSensorList
export const setSaveWaterVaporSensorList = (value) => ({
  type: SET_SAVE_WATER_VAPOR_SENSOR_LIST,
  value,
});

// ACTION CREATOR SET_SAVE_FREQUENCY_STANDARD_SENSOR_LIST
export const SET_SAVE_FREQUENCY_STANDARD_SENSOR_LIST = 'SET_SAVE_FREQUENCY_STANDARD_SENSOR_LIST';

// ACTION CREATOR setSaveFrequencyStandardSensorList
export const setSaveFrequencyStandardSensorList = (value) => ({
  type: SET_SAVE_FREQUENCY_STANDARD_SENSOR_LIST,
  value,
});

// ACTION CREATOR SET_DATE_PICKER_DATE_FROM
export const SET_DATE_PICKER_DATE_FROM = 'SET_DATE_PICKER_DATE_FROM';

// ACTION CREATOR setDatePickerDateFrom
export const setDatePickerDateFrom = (value) => ({
  type: SET_DATE_PICKER_DATE_FROM,
  value,
});

// ACTION CREATOR SET_DATE_PICKER_DATE_TO
export const SET_DATE_PICKER_DATE_TO = 'SET_DATE_PICKER_DATE_TO';

// ACTION CREATOR setDatePickerDateTo
export const setDatePickerDateTo = (value) => ({
  type: SET_DATE_PICKER_DATE_TO,
  value,
});

// ACTION CREATOR SET_CURRENT_DATE
export const SET_CURRENT_DATE = 'SET_CURRENT_DATE';

// ACTION CREATOR setCurrentDate
export const setCurrentDate = (value) => ({
  type: SET_CURRENT_DATE,
  value,
});

// ACTION CREATOR SET_HEATMAP_OPTIONS
export const SET_HEATMAP_OPTIONS = 'SET_HEATMAP_OPTIONS';

// ACTION CREATOR setHeatmapOptions
export const setHeatmapOptions = (value) => ({
  type: SET_HEATMAP_OPTIONS,
  value,
});

// ACTION CREATOR SET_LINEAR_OPTIONS
export const SET_LINEAR_OPTIONS = 'SET_LINEAR_OPTIONS';

// ACTION CREATOR setLinearOptions
export const setLinearOptions = (value) => ({
  type: SET_LINEAR_OPTIONS,
  value,
});

// ACTION CREATOR SET_SHIFTKEY
export const SET_SHIFTKEY = 'SET_SHIFTKEY';

// ACTION CREATOR setShiftKey
export const setShiftKey = (value) => ({
  type: SET_SHIFTKEY,
  value,
});

// ACTION CREATOR SET_FETCH_DATA
export const SET_FETCH_DATA = 'SET_FETCH_DATA';

// ACTION CREATOR setFetchData
export const setFetchData = (value) => ({
  type: SET_FETCH_DATA,
  value,
});

// ACTION CREATOR SAVE_CALENDAR_DATA
export const SAVE_CALENDAR_DATA = 'SAVE_CALENDAR_DATA';

// ACTION CREATOR saveCalendarData
export const saveCalendarData = (value) => ({
  type: SAVE_CALENDAR_DATA,
  value,
});

// ACTION CREATOR SAVE_DATE_ELEMENTS
export const SAVE_DATE_ELEMENTS = 'SAVE_DATE_ELEMENTS';

// ACTION CREATOR saveDateElements
export const saveDateElements = (value) => ({
  type: SAVE_DATE_ELEMENTS,
  value,
});

// ACTION CREATOR SET_DATE_SELECTED_ARRAY
export const SET_DATE_SELECTED_ARRAY = 'SET_DATE_SELECTED_ARRAY';

// ACTION CREATOR setDateSelectedArray
export const setDateSelectedArray = (value) => ({
  type: SET_DATE_SELECTED_ARRAY,
  value,
});

// ACTION CREATOR SET_DATE_HIGHLIGHT
export const SET_DATE_HIGHLIGHT = 'SET_DATE_HIGHLIGHT';

// ACTION CREATOR setDateHighlight
export const setDateHighlight = (value) => ({
  type: SET_DATE_HIGHLIGHT,
  value,
});

// ACTION CREATOR SET_OPEN_MODAL
export const SET_OPEN_MODAL = 'SET_OPEN_MODAL';

// ACTION CREATOR setOpenModal
export const setOpenModal = (value) => ({
  type: SET_OPEN_MODAL,
  value,
});

// ACTION CREATOR SET_DOWNLOAD_BUTTON
export const SET_DOWNLOAD_BUTTON = 'SET_DOWNLOAD_BUTTON';

// ACTION CREATOR setDownloadButton
export const setDownloadButton = (value) => ({
  type: SET_DOWNLOAD_BUTTON,
  value,
});

// ACTION CREATOR SET_QUALITY_DATE_PICKER_DATE_FROM
export const SET_QUALITY_DATE_PICKER_DATE_FROM = 'SET_QUALITY_DATE_PICKER_DATE_FROM';

// ACTION CREATOR setQualityDatePickerDateFrom
export const setQualityDatePickerDateFrom = (value) => ({
  type: SET_QUALITY_DATE_PICKER_DATE_FROM,
  value,
});

// ACTION CREATOR SET_QUALITY_DATE_PICKER_DATE_TO
export const SET_QUALITY_DATE_PICKER_DATE_TO = 'SET_QUALITY_DATE_PICKER_DATE_TO';

// ACTION CREATOR setQualityDatePickerDateTo
export const setQualityDatePickerDateTo = (value) => ({
  type: SET_QUALITY_DATE_PICKER_DATE_TO,
  value,
});

// ACTION CREATOR SAVE_QUALITY_DATA
export const SAVE_QUALITY_DATA = 'SAVE_QUALITY_DATA';

// ACTION CREATOR saveQualityData
export const saveQualityData = (value) => ({
  type: SAVE_QUALITY_DATA,
  value,
});

// ACTION CREATOR SET_QUALITY_HIGHCHARTS
export const SET_QUALITY_HIGHCHARTS = 'SET_QUALITY_HIGHCHARTS';

// ACTION CREATOR setQualityHighcharts
export const setQualityHighcharts = (value) => ({
  type: SET_QUALITY_HIGHCHARTS,
  value,
});

// ACTION CREATOR SET_FETCH_DOI_AND_LICENCE
export const SET_FETCH_DOI_AND_LICENCE = 'SET_FETCH_DOI_AND_LICENCE';

// ACTION CREATOR setFetchDoiAndLicence
export const setFetchDoiAndLicence = (value) => ({
  type: SET_FETCH_DOI_AND_LICENCE,
  value,
});

// ACTION CREATOR SAVE_DOI_AND_LICENCE
export const SAVE_DOI_AND_LICENCE = 'SAVE_DOI_AND_LICENCE';

// ACTION CREATOR SaveDoiAndLicence
export const SaveDoiAndLicence = (value) => ({
  type: SAVE_DOI_AND_LICENCE,
  value,
});

// ACTION CREATOR DISPLAY_DOI
export const DISPLAY_DOI = 'DISPLAY_DOI';

// ACTION CREATOR DisplayDOI
export const DisplayDOI = (value) => ({
  type: DISPLAY_DOI,
  value,
});

// ACTION CREATOR SET_FETCH_IMAGES
export const SET_FETCH_IMAGES = 'SET_FETCH_IMAGES';

// ACTION CREATOR setFetchImages
export const setFetchImages = (value) => ({
  type: SET_FETCH_IMAGES,
  value,
});

// ACTION CREATOR SAVE_IMAGES
export const SAVE_IMAGES = 'SAVE_IMAGES';

// ACTION CREATOR SaveImages
export const SaveImages = (value) => ({
  type: SAVE_IMAGES,
  value,
});

// ACTION CREATOR DISPLAY_IMAGES
export const DISPLAY_IMAGES = 'DISPLAY_IMAGES';

// ACTION CREATOR DisplayImages
export const DisplayImages = (value) => ({
  type: DISPLAY_IMAGES,
  value,
});

// ACTION CREATOR SAVE_TIME_SERIES
export const SAVE_TIME_SERIES = 'SAVE_TIME_SERIES';

// ACTION CREATOR SaveTimeSeries
export const SaveTimeSeries = (value) => ({
  type: SAVE_TIME_SERIES,
  value,
});

// ACTION CREATOR SET_RESPONSE_IMAGE
export const SET_RESPONSE_IMAGE = 'SET_RESPONSE_IMAGE';

// ACTION CREATOR setResponseImage
export const setResponseImage = (value) => ({
  type: SET_RESPONSE_IMAGE,
  value,
});
